/*!
 * devextreme-angular
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

import { CollectionNestedOption } from 'devextreme-angular-rpk/core';


export abstract class DxiGanttStripLine extends CollectionNestedOption {
    get cssClass(): string {
        return this._getOption('cssClass');
    }
    set cssClass(value: string) {
        this._setOption('cssClass', value);
    }

    get end(): Date | number | Function | string {
        return this._getOption('end');
    }
    set end(value: Date | number | Function | string) {
        this._setOption('end', value);
    }

    get start(): Date | number | Function | string {
        return this._getOption('start');
    }
    set start(value: Date | number | Function | string) {
        this._setOption('start', value);
    }

    get title(): string {
        return this._getOption('title');
    }
    set title(value: string) {
        this._setOption('title', value);
    }
}
